import React from 'react'
// import { errorCodeToMessage } from '@@partner:helpers/errors'

import { Message } from 'rsuite'

// import './FormElementErrorDisplay.scss'

export interface FormElementErrorDisplayProps {
  field: string
  error?: Record<string, any>
}

const FormElementErrorDisplay: React.FC<FormElementErrorDisplayProps> = ({
  field,
  error,
  children
}) => {
  if (field && error && error[field]) {
    return (
      <Message className="FormElementErrorDisplay" type="error" showIcon>
        <p>
          <strong>{error[field]}</strong>
        </p>

        {children}
      </Message>
    )
  }
  return null
}

export default FormElementErrorDisplay
